export const DATETIME_FORMAT = 'dd.MM.yyyy, HH:mm';

export const DATE_FORMAT = 'dd.MM.yyyy';
